import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import React from 'react';
import logoHostVSL from '@/assets/logo-hostvsl-white.png';
import { generateWhatsAppLink } from '@/lib/utils/whatsapp';

interface TemplateLightFooterProps {
  showTerms?: boolean;
  showPrivacy?: boolean;
  showWhatsapp?: boolean;
  termsUrl?: string;
  privacyUrl?: string;
  whatsappNumber?: string;
  whatsappMessage?: string;
}

export function TemplateLightFooter({
  showTerms = true,
  showPrivacy = true,
  showWhatsapp = false,
  termsUrl = '#',
  privacyUrl = '#',
  whatsappNumber = '',
  whatsappMessage = '',
}: TemplateLightFooterProps) {
  useLanguage();
  const links = [
    { show: showTerms, label: translateInterfaceText("Termos de Uso"), url: termsUrl, isExternal: false },
    { show: showPrivacy, label: translateInterfaceText("Privacidade"), url: privacyUrl, isExternal: false },
    { show: showWhatsapp && whatsappNumber, label: translateInterfaceText("WhatsApp"), url: generateWhatsAppLink(whatsappNumber, whatsappMessage), isExternal: true },
  ].filter((link) => link.show);

  return (
    <footer 
      className="px-8 py-3"
      style={{ 
        backgroundColor: '#0A4DFF'
      }}
    >
      <div className="max-w-[1400px] mx-auto px-4 lg:px-10 flex flex-col lg:flex-row items-center gap-2 lg:gap-0">
        
        {/* Desktop: Coluna esquerda (65%) - alinha com player */}
        <div className="hidden lg:flex flex-[0_0_65%] max-w-[900px] items-center gap-1.5 text-[13px] text-white/80 whitespace-nowrap">
          <span>{translateInterfaceText("Tecnologia de")}</span>
          <a 
            href="https://www.hostvsl.com.br"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:opacity-80 transition-opacity"
          >
            <img 
              src={logoHostVSL} 
              alt={translateInterfaceText("HostVSL")}
              className="h-4 w-auto"
            />
          </a>
        </div>

        {/* Desktop: Coluna direita - alinha com sidebar da playlist */}
        {links.length > 0 && (
          <div 
            className="hidden lg:flex items-center gap-3 text-[13px] text-white/80 whitespace-nowrap"
            style={{ width: '360px', minWidth: '360px' }}
          >
            {links.map((link, index) => (
              <React.Fragment key={index}>
                {index > 0 && <span className="text-white/40">•</span>}
                <a
                  href={link.url}
                  target={link.isExternal ? "_blank" : undefined}
                  rel={link.isExternal ? "noopener noreferrer" : undefined}
                  className="hover:text-white transition-colors"
                >
                  {link.label}
                </a>
              </React.Fragment>
            ))}
          </div>
        )}

        {/* Mobile: Centralizado */}
        <div className="flex lg:hidden flex-col items-center gap-2">
          <div className="flex items-center gap-1.5 text-[13px] text-white/80 whitespace-nowrap">
            <span>{translateInterfaceText("Tecnologia de")}</span>
            <a 
              href="https://www.hostvsl.com.br"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:opacity-80 transition-opacity"
            >
              <img 
                src={logoHostVSL} 
                alt={translateInterfaceText("HostVSL")}
                className="h-4 w-auto"
              />
            </a>
          </div>

          {links.length > 0 && (
            <div className="flex items-center justify-center gap-3 text-[13px] text-white/80 whitespace-nowrap">
              {links.map((link, index) => (
                <React.Fragment key={index}>
                  {index > 0 && <span className="text-white/40">•</span>}
                  <a
                    href={link.url}
                    target={link.isExternal ? "_blank" : undefined}
                    rel={link.isExternal ? "noopener noreferrer" : undefined}
                    className="hover:text-white transition-colors"
                  >
                    {link.label}
                  </a>
                </React.Fragment>
              ))}
            </div>
          )}
        </div>

      </div>
    </footer>
  );
}
